import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';

import Resume from "../../files/resume.pdf";
import "./Contact.scss";

class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {

        let bio = this.state.data.bio;
        let name = this.state.data.name;
        let email = this.state.data.email;
        let phoneLabel = this.state.data.phoneLabel;
        let phone = this.state.data.phone;

        return (
            <section id="contact">
                <Container fluid>
                    <Row>
                        <Fade left delay={200} duration={800} distance="20%" fraction={1}>
                            <h2 className="section-title">Contact</h2>
                        </Fade>
                        <Fade right delay={400} duration={800} distance="500px" fraction={1}>
                            <div className="section-title-underline"></div>
                        </Fade>
                    </Row>
                    <Row className="contact-phone-section">
                        <Flip bottom delay={400} duration={1000} fraction={1}>
                            <a className="contact-phone" href={`tel:${phone}`}>
                                <FontAwesomeIcon icon={faPhone} />
                                <span>{phoneLabel}</span>
                            </a>
                        </Flip>
                    </Row>
                    <Row className="contact-email-section">
                        <Flip bottom delay={600} duration={1000} fraction={1}>
                            <a className="contact-email" href={`mailto:${email}`}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <span>{email}</span>
                            </a>
                        </Flip>
                    </Row>
                </Container>
            </section>
        );
    }
};

export default Contact;
